import { t } from "@lingui/macro";

import { EmptyStateIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import { Box, Text } from "@whoosh/design-system/src/components/primitive";

export const EmptyBookingList = () => {
  return (
    <Box
      justifyContent="center"
      height={{ base: 68, md: 123 }}
      alignItems="center"
      style={{ height: 170, marginTop: 8, marginBottom: 278 }}
    >
      <EmptyStateIcon />
      <Text
        variant="mainBaseMedium"
        mt={6}
        color="text-primary"
        style={{ maxWidth: 233 }}
        textAlign="center"
      >
        {t`There are no past bookings to display right now.`}
      </Text>
    </Box>
  );
};
